<template>
  <div class="-error-state">
    <div class="-big-label">
      {{ 'fullPreview.PREVIEW_VIDEO_ERROR' | culture }}
    </div>
    <div class="-small-label">
      <span class="wt2-text-n wt2-color-negative">{{
        'fullPreview.PREVIEW_VIDEO_ERROR_DESCRIPTION' | culture
      }}</span>
      <a
        class="-contact wt2-text-n wt2-color-negative"
        @click.prevent="contactSupport"
        >{{ 'fullPreview.PREVIEW_VIDEO_ERROR_SUPPORT' | culture }}</a
      >
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  props: {
    videoId: {
      type: String,
      default: '',
    },
  },

  methods: {
    contactSupport() {
      const message = app.culture
        .get('fullPreview.PREVIEW_VIDEO_ERROR_INTERCOM')
        .format(this.videoId);
      app.intercomController.showNewMessage(message).catch(() => {
        // fallback - if there no intercom, go to website support
        app.openSupportTab();
      });
    },
  },
};
</script>

<style lang="scss">
@import 'style_guide/_sg_variables.scss';

.-error-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  color: $color-white;
  // background-color: $bgcolor-fullpreview;

  .-big-label {
    font-size: $font-size-lm;
    font-weight: $font-weight-light;
  }

  .-small-label {
    margin-top: 5px;
    font-size: $font-size-n;
    font-weight: $font-weight-light;
  }

  .-contact {
    // font-weight: $font-weight-medium;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
